import { Component } from '@angular/core';

@Component({
    selector: 'app-ui-blocker',
    template: `
    <div class="ui-blocker">
        <div class="ui-block-spinner">
            <div class="spinner-border text-info" role="status">
                <span class="visually-hidden"></span>
            </div>
        </div>
    </div>`,
    styles: [`
    .ui-blocker {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 9999;
    }
    .ui-blocker .ui-block-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `],
    standalone: true
})
export class UiBlockerComponent {}
